/**
 * FontSelector
 */
export class FontSelector {
  /**
   * @param {HTMLElement} elem
   * @param {Object} options
   */
  constructor(elem, options) {
    // Set options
    this._options = {
      disableSwitch: false,
    };

    if (typeof options === 'object') {
      this._options = Object.assign({}, this._options, options);
    }

    // Dom elements
    this._elem = elem;
    this._buttonsGroups = elem.querySelectorAll('[data-toggle="buttons-radio"]');
    this._wrapper = elem.querySelector('.font-selector-wrapper');
    this._switch = elem.querySelector('.font-selector-switch');
    this._selection = elem.querySelector('.font-selector-selection');
    this._select = elem.querySelector('.font-selector-select');
    this._properties = {};

    this._init();
  }

  /**
   * @private
   */
  _init() {
    let fonts = [
      {
        label: ($(this._elem).attr('data-default-font-label') ?
          $(this._elem).attr('data-default-font-label') :
          'Default'),
        value: '',
      },
    ];

    if ('fonts' in this._options) {
      fonts = fonts.concat(this._options.fonts);
    }

    fonts.forEach((font) => {
      $(this._select).append(`<option value="${font.value}" style="font-family: ${font.value}">${font.label}</option>`);
    });

    if (!this._options.disableSwitch) {
      // Component toggle
      this._switch.addEventListener('change', () => {
        this.toggle();
      });
    } else {
      $(this._switch).parents('.form-check').hide();
      this._wrapper.style.display = 'block';
    }

    // Store CSS avalaible properties
    this._wrapper.querySelectorAll('[data-property]').forEach((input) => {
      // Listen input's change
      input.addEventListener('change', (e) => {
        this._setSelection(e.target);
      });
    });

    // Init font color picker

    const input = this._wrapper.querySelector('[data-property="color"]');

    $(input).spectrum('set', '').on('change.spectrum', () => {
      this._setSelection(input);
    });

    this._loadValue();

    // Event click on buttons
    this._buttonsGroups.forEach((buttonGroup, i) => {
      const property = this._buttonsGroups[i].getAttribute('data-target');
      const target = this._wrapper.querySelector(`[data-property="${property}"]`);
      const buttons = this._buttonsGroups[i].querySelectorAll('a');

      buttons.forEach((button, i) => {
        button.addEventListener('click', (e) => {
          const selected = e.target.classList.contains('selected');
          const value = !selected ? button.getAttribute('data-value') : '';

          // toggle .selected class
          if (selected === false) {
            if (buttonGroup.querySelector('.selected') !== null) {
              buttonGroup.querySelector('.selected').classList.remove('selected');
            }
            e.target.classList.add('selected');
          } else {
            e.target.classList.remove('selected');
          }

          // Assign value to hidden input
          target.value = value;
          // Trigger input's change event
          target.dispatchEvent(new Event('change'));
        });
      });
    });
  }

  /**
   * @private
   */
  _loadValue() {
    // Get selection
    if (this._selection.value.trim() !== '') {
      this._selection.value.split(';').forEach((value) => {
        if (value.trim() === '') {
          return;
        }

        const property = value.split(':')[0].trim();
        value = value.split(':')[1].trim();

        this._properties[property] = value;
      });
    }

    if (!this._options.disableSwitch) {
      if (Object.keys(this._properties).length !== 0) {
        $(this._switch).prop('checked', true);
        this._wrapper.style.display = 'block';
      } else {
        $(this._switch).prop('checked', false);
        this._wrapper.style.display = 'none';
      }
    }

    // Set selection
    Object.keys(this._properties).forEach((property) => {
      const input = this._wrapper.querySelector(`[data-property="${property}"]`);

      input.value = this._properties[property];

      // Init font color picker
      if (property === 'color') {
        $(input).spectrum('set', input.value);
      }

      // Add .selected class on buttons
      this._selectedButton(property);
    });
  }

  /**
   * @param {HTMLElement} input
   * @private
   */
  _setSelection(input) {
    const property = input.getAttribute('data-property');
    const value = input.value.replace('+', ' ');

    // Store CSS property
    this._properties[property] = value;

    // Set selection
    const selection = [];

    // Get CSS properties
    Object.keys(this._properties).forEach((property) => {
      if (this._properties[property] !== '') {
        selection.push(`${property}:${this._properties[property]}`);
      }
    });

    // Write selection
    this._selection.value = selection.join(';');

    $(this._elem).trigger('font.change', [this._selection.value, this]);
  }

  /**
   * Init .selected class on buttons
   * @param {string} property
   * @private
   */
  _selectedButton(property) {
    const buttonsGroup = this._wrapper.querySelector(`[data-target="${property}"]`);

    // Isset button group ?
    if (buttonsGroup !== null) {
      const value = this._properties[property];

      // Add selected class on right value
      if (buttonsGroup.querySelector(`[data-value="${value}"]`) !== null) {
        buttonsGroup.querySelector(`[data-value="${value}"]`).classList.add('selected');
      }
    }
  }

  /**
   * @return {FontSelector}
   */
  reset() {
    this._properties = {};
    this._selection.value = '';

    // Remove .selected class on buttons
    this._buttonsGroups.forEach((buttonGroup, i) => {
      const selectedButton = this._buttonsGroups[i].querySelector('.selected');

      if (selectedButton !== null) {
        selectedButton.classList.remove('selected');
      }
    });

    // Defaults select
    this._elem.querySelectorAll('select').forEach((select, i) => {
      const options = select.querySelectorAll('option');
      options.forEach((option, o) => {
        options[o].selected = options[o].defaultSelected;
      });
    });

    // Reset color picker
    const colorPicker = this._wrapper.querySelector(`[data-property="color"]`);
    colorPicker.value = '';
    $(colorPicker).spectrum('set', '');

    $(this._elem).trigger('font.change', [this._selection.value, this]);

    return this;
  }

  /**
   * @return {FontSelector}
   */
  toggle() {
    if (this._wrapper.offsetParent === null) {
      this._wrapper.style.display = 'block';
    } else {
      this._wrapper.style.display = 'none';
      this.reset();
    }

    return this;
  }

  /**
   * @param {string} value
   * @return {FontSelector}
   */
  setValue(value) {
    this.reset();
    this._selection.value = value;
    this._loadValue();

    $(this._elem).trigger('font.change', [this._selection.value, this]);

    return this;
  }

  /**
   * @return {string}
   */
  getValue() {
    return this._selection.value;
  }
}
